export default __webpack_public_path__ + "static/media/information_icon.cb6be484.svg";